import { useRef, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import CanvasEditor from './CanvasEditor';

const CanvasEditorDialog = ({
	open,
	value,
	onClose,
	onSave,
	className,
}: {
	open: boolean;
	value: string;
	className?: string;
	onClose: () => void;
	onSave: (data: string) => void;
}) => {
	const [canvasData, setCanvasData] = useState(value);
	const saveFnRef = useRef<Function | null>(null);
	const canvasDataRef = useRef<any>(null);

	return (
		<Modal show={open} onHide={onClose} size="xl" centered>
			<Modal.Header closeButton>
				<Modal.Title>Canvas Editor</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<CanvasEditor
					value={canvasData}
					onSave={(value) => {
						setCanvasData(value);
						canvasDataRef.current = value;
					}}
					className={className}
					setSaveFn={(fn) => {
						saveFnRef.current = fn;
					}}
				/>
			</Modal.Body>
			<Modal.Footer>
				<Button className="btn-fill btn-danger" onClick={onClose}>
					Đóng
				</Button>
				<Button
					className="btn-fill"
					onClick={() => {
						saveFnRef.current?.();
						onSave(canvasDataRef.current);
					}}
				>
					Xác nhận
				</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default CanvasEditorDialog;
